// extracted by mini-css-extract-plugin
export default {"mainTitle":"News_mainTitle__k9mEj"};